<template>
  <div id="support-modal" class="modal" v-show="modalShown">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef"/>
    <div class="modal-main">
      <div class="title-area">
        <h2>お問い合わせフォーム</h2>
      </div>
      <div class="data-area">
        <ul>
          <li>
            <span class="label">お問い合わせ区分</span>
            <select v-model.number="type">
              <option v-for="(type,index) in typeList" :key="index" :value="type.num">{{type.code}}</option>
            </select>
            <div class="error_message">{{ fieldErrorMessages.type }}</div>
          </li>
          <li>
            <span class="label">件名</span>
            <input type="text" v-model="title">
            <div class="error_message">{{ fieldErrorMessages.title }}</div>
          </li>
          <li>
            <span class="label support_body_pos">お問い合わせ内容</span>
            <textarea rows="10" maxlength="256" v-model="body"></textarea>
            <div class="error_message">{{ fieldErrorMessages.body }}</div>
          </li>
        </ul>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="onTransmit">送信</button>
        <button type="button" class="main_btn" @click="closeModal">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import {API_URL} from '../../constants/App'
import LoadingModal from '../common/LoadingModal'

export default {
  name: 'ContactModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** お知らせ区分 */
      typeList: [
        {code: 'daros導入についてのお問い合わせ', num: 1},
        {code: 'daros機能についてのお問い合わせ', num: 2},
        {code: '取材についてのお問い合わせ', num: 3},
        {code: 'その他お問い合わせ', num: 4}
      ],
      /** お知らせ区分 */
      type: '',
      /** 件名 */
      title: '',
      /** 内容 */
      body: '',
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        type: '',
        title: '',
        body: ''
      }
    }
  },
  methods: {
    showModal: function (code) {
      this.type = code != null ? code : ''
      this.title = ''
      this.body = ''
      this.modalShown = true
    },
    closeModal: function () {
      this.modalShown = false
      // キャンバスのイベントリスナを有効化
      this.$emit('closeContact')
    },
    onTransmit: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        type: this.type,
        title: this.title,
        body: this.body
      }
      axios.post(API_URL.SUPPORT + '/support', payload
      ).then(response => {
        this.closeModal()
        alert('送信しました')
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  .label{
    min-width: 135px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
select{
  width: 295px;
}
textarea {
  resize: none;
  width: 270px;
}
input{
  width: 270px;
}
.support_body_pos{
  position: relative;
  top: -184px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/SupportModal.vue